import React,{useState,useEffect} from 'react';
import { T, MONO, shadow } from './poyais-ui/theme';
import { ScreenHeader } from './poyais-ui/shell';
import { Icon } from './poyais-ui/icons';
import { useLang, addTranslations } from './i18n';
import PoyaisSpinner from './PoyaisSpinner';
import { detectCountry } from './countries';
import { track } from './analytics';

addTranslations({
  'Google Ads + Meta': 'Google Ads + Meta',
  'GA4 Entegrasyonu': 'GA4 Integration',
  'RTB House & Criteo': 'RTB House & Criteo',
  'Haftalık AI Raporu': 'Weekly AI Report',
  'Asistan': 'Assistant',
  'Feed Builder / Dynamic Feed': 'Feed Builder / Dynamic Feed',
  'Otomasyon Şablonları': 'Automation Templates',
  'Akış Oluşturucu': 'Flow Builder',
  'Kampanya Oluşturucu': 'Campaign Builder',
  'AI Radar': 'AI Radar',
  'AI Radar (Ayda {n} Tarama)': 'AI Radar ({n} Scans/Month)',
  'Ekip Üyesi': 'Team Member',
  'Sınırsız Optimizasyon Kuralı': 'Unlimited Optimization Rules',
  'Optimizasyon Kuralı': 'Optimization Rules',
  'Deneme Süresi': 'Trial Period', 'Aktif': 'Active', 'Ödeme Gecikti': 'Payment Overdue',
  'İptal Edilecek': 'Will Be Canceled', 'Pasif': 'Inactive',
  'Bir hata oluştu': 'Something went wrong',
  'Aboneliğinizi dönem sonunda iptal etmek istediğinize emin misiniz?': 'Are you sure you want to cancel your subscription at the end of the period?',
  'İşlem tamamlandı': 'Done',
  'PLAN BİLGİLERİ YÜKLENİYOR': 'LOADING PLAN INFO',
  'Faturalandırma': 'Billing',
  'Mevcut planınızı görüntüleyin, yükseltin veya yönetin.': 'View, upgrade, or manage your current plan.',
  'Mevcut Plan': 'Current Plan',
  'Özel Plan (Admin)': 'Custom Plan (Admin)',
  'Başlangıç': 'Starter',
  'tarihine kadar': 'until',
  'İşleniyor...': 'Processing...',
  'Aboneliği İptal Et': 'Cancel Subscription',
  'MEVCUT PLAN': 'CURRENT PLAN',
  'EN POPÜLER': 'MOST POPULAR',
  'Özel': 'Custom',
  '/ay': '/mo',
  'Yönlendiriliyor...': 'Redirecting...',
  'Bu Plana Geç': 'Switch to This Plan',
  'İletişime Geç': 'Contact Us',
  'Şu anki planınız': 'Your current plan',
  'Fiyatlar aylık faturalandırılır, istediğiniz zaman iptal edebilirsiniz.': 'Prices are billed monthly, you can cancel anytime.',
  'Mevcut plan': 'Current plan', 'Aboneliğiniz Shopify üzerinden faturalandırılır. Planı değiştirmek veya iptal etmek için Shopify yönetim panelini kullanın.': 'Your subscription is billed through Shopify. Use your Shopify admin to change or cancel your plan.', "Shopify'da planı yönet": 'Manage plan in Shopify', 'Yenileniyor...': 'Refreshing...', 'Durumu yenile': 'Refresh status',
  'Aylık': 'Monthly', 'Yıllık': 'Annual', '%20 indirim': '20% off',
  'Türkiye (₺)': 'Türkiye (₺)', "Türkiye'deki hesaplar TL ile iyzico üzerinden öder.": 'Accounts in Türkiye pay in TRY via iyzico.', 'Yurt dışı ($)': 'International ($)',
  '+ KDV /ay': '+ VAT /mo',
  "Fiyatlar KDV ve diğer vergiler hariçtir. Türkiye'den ödemeler iyzico ile TL, yurt dışından ödemeler Stripe ile USD olarak alınır; yurt dışında geçerli vergi ödeme adımında eklenir. İstediğiniz zaman iptal edebilirsiniz.": 'Prices exclude VAT and other taxes. Payments from Türkiye are taken in TRY via iyzico, international payments in USD via Stripe; applicable taxes outside Türkiye are added at checkout. You can cancel anytime.',
  'Ödeme Bilgileri': 'Payment Details',
  'Fatura Bilgileri': 'Billing Details',
  'Ad Soyad': 'Full Name', 'Firma Unvanı (Opsiyonel)': 'Company Name (Optional)',
  'TC Kimlik No / Vergi No': 'Turkish ID / Tax Number', 'Vergi Dairesi (Opsiyonel)': 'Tax Office (Optional)',
  'Telefon': 'Phone', 'Adres': 'Address', 'Şehir': 'City', 'Posta Kodu (Opsiyonel)': 'Postal Code (Optional)',
  'Ara Toplam': 'Subtotal', 'KDV (%20)': 'VAT (20%)', 'Toplam': 'Total',
  'Ayda bir tahsil edilir': 'Charged monthly', 'Yılda bir tahsil edilir': 'Charged annually',
  "'ni okudum, kabul ediyorum.": ' — I have read and accept.',
  'Mesafeli Satış Sözleşmesi': 'Distance Sales Agreement', 'Teslimat ve İade Koşulları': 'Delivery and Refund Policy',
  've': 'and',
  'iyzico ile Öde': 'Pay with iyzico', 'Vazgeç': 'Cancel',
  'Lütfen sözleşmeyi onaylayın.': 'Please accept the agreement.',
  'Ödeme alındı, planınız aktif.': 'Payment received, your plan is active.',
  'Ödeme tamamlanamadı.': 'Payment could not be completed.',
  'Ödeme süresi doldu, tekrar deneyin.': 'The payment session expired, please try again.',
  'tarihinde sona erecek': 'ends on',
  'Abonelik dönem sonunda iptal edilecek': 'Subscription will be canceled at the end of the period',
});

const RECOMMENDED_PLAN = 'professional';


const PLAN_STATUS_LABEL: Record<string,{label:string;color:string;bg:string}> = {
  trialing: { label:'Deneme Süresi', color: T.blue, bg:'var(--py-blue-tint)' },
  active: { label:'Aktif', color: T.greenText, bg:'var(--py-green-tint)' },
  past_due: { label:'Ödeme Gecikti', color: T.redText, bg:'var(--py-red-tint)' },
  canceling: { label:'İptal Edilecek', color: T.amberText, bg:'var(--py-amber-tint-alt)' },
  inactive: { label:'Pasif', color: T.textDim, bg:T.card },
};


async function resolveActiveClientId(): Promise<number|null> {
  const stored = localStorage.getItem('poyais_active_client');
  if (stored) return parseInt(stored);
  // localStorage henüz hiç ayarlanmamışsa (ör. taze oturum) 1'e sabitleme yerine
  // gerçek erişilebilir müşteri listesinden ilkini al — yoksa yanlış/var olmayan
  // bir client_id'ye düşüp durum isteği sessizce 404'e düşüyordu.
  try {
    const tok = localStorage.getItem('poyais_token')||localStorage.getItem('token')||'';
    const res = await fetch('/api/v1/clients/', { headers:{ 'Authorization':'Bearer '+tok } });
    const list = await res.json();
    return Array.isArray(list) && list.length > 0 ? list[0].id : null;
  } catch { return null; }
}

const MESAFELI_URL='https://poyaisone.com/mesafeli-satis-sozlesmesi';
const IADE_URL='https://poyaisone.com/teslimat-ve-iade';
const VAT_RATE=0.2;
const EMPTY_BILLING={name:'',company:'',identity:'',tax_office:'',phone:'',address:'',city:'',zip:''};
type Region='tr'|'intl';
type Cycle='monthly'|'yearly';

function tl(v:number, frac=0){ return '₺'+v.toLocaleString('tr-TR',{minimumFractionDigits:frac,maximumFractionDigits:frac}); }

const FaturalandirmaPage:React.FC<{config?:any}>=()=>{
  const { t, lang } = useLang();
  const [shopifyShop, setShopifyShop] = useState('');
  const [shopifySyncing, setShopifySyncing] = useState(false);
  const [status,setStatus]=useState<any>(null);
  const [plans,setPlans]=useState<Record<string,any>>({});
  const [loading,setLoading]=useState(true);
  const [actionLoading,setActionLoading]=useState('');
  const [toast,setToast]=useState('');
  const [cycle,setCycle]=useState<Cycle>('monthly');
  const [checkoutPlan,setCheckoutPlan]=useState<string|null>(null);
  const [billing,setBilling]=useState<Record<string,string>>(EMPTY_BILLING);
  const [agreed,setAgreed]=useState(false);
  const [formError,setFormError]=useState('');
  const token=()=>localStorage.getItem('poyais_token')||localStorage.getItem('token')||'';
  const headers={'Content-Type':'application/json','Authorization':'Bearer '+token()};

  useEffect(()=>{
    (async()=>{
      // Admin hesaplar kendi (özel/enterprise) abonelik durumunu görmeli, o an
      // sidebar'da hangi müşteri seçili olursa olsun — o yüzden client_id'yi
      // sadece admin olmayan kullanıcılar için ekliyoruz. Aksi halde admin bu
      // sayfayı açtığında her zaman seçili müşterinin planı (ör. "Başlangıç")
      // gösteriliyordu, admin'in kendi durumu hiç sorulmuyordu.
      let isAdmin = false;
      try {
        const me = await fetch('/api/v1/auth/me',{headers}).then(r=>r.json());
        isAdmin = me?.role === 'admin';
      } catch {}
      const clientId = isAdmin ? null : await resolveActiveClientId();
      const statusUrl = clientId ? `/api/v1/subscription/status?client_id=${clientId}` : '/api/v1/subscription/status';
      Promise.all([
        fetch(statusUrl,{headers}).then(r=>r.json()),
        fetch('/api/v1/subscription/plans',{headers}).then(r=>r.json()),
      ]).then(([s,p])=>{
        setStatus(s);
        setPlans(p.plans||{});
      }).catch(()=>{}).finally(()=>setLoading(false));
    })();
  },[]);

  // iyzico ödeme sayfasından dönüş: /hesap/faturalandirma?checkout=success|failed|expired
  useEffect(()=>{
    const params=new URLSearchParams(window.location.search);
    const result=params.get('checkout');
    if(!result) return;
    if(result==='success') track('subscription_success', { provider: 'iyzico', currency: 'TRY' }); // ?checkout parametresi hemen silindiği için tekrar saymaz
    showToast(result==='success' ? t('Ödeme alındı, planınız aktif.') : result==='expired' ? t('Ödeme süresi doldu, tekrar deneyin.') : t('Ödeme tamamlanamadı.'), 5000);
    params.delete('checkout');
    const q=params.toString();
    window.history.replaceState({},'',window.location.pathname+(q?`?${q}`:''));
  },[]);

  const showToast=(m:string, ms=3000)=>{ setToast(m); setTimeout(()=>setToast(''),ms); };

  // Ödeme bölgesi otomatik: Türkiye'deki hesaplar iyzico + TL, diğer ülkeler Stripe + USD. Kaynak sırası:
  // abonelik sağlayıcısı → hesabın fatura ülkesi (kayıt formunda alınır) → tarayıcı tahmini (eski hesaplar için).
  const guess = detectCountry();
  const region: Region =
    status?.provider==='iyzico' ? 'tr'
    : status?.billing_country ? (status.billing_country.toUpperCase()==='TR' ? 'tr' : 'intl')
    : guess ? (guess==='TR' ? 'tr' : 'intl')
    : (lang==='en' ? 'intl' : 'tr');

  const handleUpgrade=async(planId:string)=>{
    const clientId = await resolveActiveClientId();
    if(region==='tr'){
      setFormError(''); setAgreed(false); setBilling(EMPTY_BILLING); setCheckoutPlan(planId);
      if(clientId){
        fetch(`/api/v1/iyzico/billing-info?client_id=${clientId}`,{headers}).then(r=>r.ok?r.json():null)
          .then(d=>{ if(d) setBilling({...EMPTY_BILLING,...d}); }).catch(()=>{});
      }
      return;
    }
    setActionLoading(planId);
    track('begin_checkout', { plan: planId, cycle, provider: 'stripe', currency: 'USD' });
    fetch('/api/v1/subscription/checkout',{
      method:'POST', headers,
      body: JSON.stringify({plan_id:planId, client_id:clientId, cycle, locale:lang}),
    }).then(r=>r.json()).then(d=>{
      if(d.checkout_url){ window.location.href = d.checkout_url; }
      else { showToast(d.detail||t('Bir hata oluştu')); setActionLoading(''); }
    }).catch(()=>{ showToast(t('Bir hata oluştu')); setActionLoading(''); });
  };

  const submitIyzico=async()=>{
    if(!checkoutPlan) return;
    if(!agreed){ setFormError(t('Lütfen sözleşmeyi onaylayın.')); return; }
    setFormError(''); setActionLoading('iyzico');
    const clientId = await resolveActiveClientId();
    track('begin_checkout', { plan: checkoutPlan, cycle, provider: 'iyzico', currency: 'TRY' });
    try{
      const res=await fetch('/api/v1/iyzico/subscription/checkout',{method:'POST',headers,
        body:JSON.stringify({client_id:clientId, plan_id:checkoutPlan, cycle, billing, agreement_accepted:true})});
      const d=await res.json();
      if(res.ok && d.pay_url){ window.location.href=d.pay_url; return; }
      setFormError(d.detail||t('Bir hata oluştu'));
    }catch{ setFormError(t('Bir hata oluştu')); }
    setActionLoading('');
  };

  const handleCancel=async()=>{
    if(!window.confirm(t('Aboneliğinizi dönem sonunda iptal etmek istediğinize emin misiniz?'))) return;
    setActionLoading('cancel');
    const clientId = await resolveActiveClientId();
    const url = status?.provider==='iyzico' ? '/api/v1/iyzico/subscription/cancel' : '/api/v1/subscription/cancel';
    fetch(url,{method:'POST',headers,body:JSON.stringify({client_id:clientId})})
      .then(async r=>{ const d=await r.json(); if(!r.ok) throw new Error(d.detail);
        showToast(t('Abonelik dönem sonunda iptal edilecek'));
        setStatus((s:any)=>({...s, plan_status:'canceling', plan_ends_at:d.ends_at||s?.plan_ends_at}));
      }).catch((e:any)=>showToast(e?.message||t('Bir hata oluştu'))).finally(()=>setActionLoading(''));
  };

  useEffect(()=>{
    if(status?.provider!=='shopify') return;
    (async()=>{
      try{
        const cid = await resolveActiveClientId();
        const tok = localStorage.getItem('poyais_token')||localStorage.getItem('token')||'';
        const d = await fetch(`/api/v1/shopify/status?client_id=${cid}`,{headers:{Authorization:'Bearer '+tok}}).then(r=>r.json());
        setShopifyShop(d?.shop_domain||'');
      }catch{}
    })();
  },[status?.provider]);
  if (loading) return <div className="py-pageload"><PoyaisSpinner size={38} pad={0}/></div>;

  const currentPlanId = (status?.plan && status.plan !== 'admin') ? status.plan : (status?.plan === 'admin' ? 'enterprise' : 'starter');
  const currentPlanDef = plans[currentPlanId];
  const statusInfo = PLAN_STATUS_LABEL[status?.plan_status] || PLAN_STATUS_LABEL.inactive;
  const planOrder = ['starter','professional','enterprise'];
  const hasSubscription = !!(status?.has_subscription || status?.stripe_subscription_id);
  // Aktif ücretli abonelikte yalnızca mevcut planın kartı "mevcut" sayılır; deneme/pasif
  // hesaplarda her ücretli plan satın alınabilir (Başlangıç'ta 14 gün deneme, kart ödeme adımında tanımlanır)
  const isPaidCurrent = (planId:string) => planId === currentPlanId && hasSubscription;

  const netMonthly=(p:any)=> cycle==='yearly' ? p.price_try_yearly_monthly : p.price_try;
  const checkoutDef = checkoutPlan ? plans[checkoutPlan] : null;
  const checkoutNet = checkoutDef ? (cycle==='yearly' ? checkoutDef.price_try_yearly_monthly*12 : checkoutDef.price_try) : 0;
  const checkoutVat = Math.round(checkoutNet*VAT_RATE*100)/100;

  const segBtn=(active:boolean)=>({padding:'7px 14px',borderRadius:8,border:'none',cursor:'pointer',fontSize:12,fontWeight:700,
    background:active?T.surface:'transparent',color:active?T.text:T.textMid,boxShadow:active?shadow.card:'none'} as React.CSSProperties);
  const inputStyle:React.CSSProperties={width:'100%',boxSizing:'border-box',padding:'10px 12px',borderRadius:9,border:`1px solid ${T.border}`,
    background:T.surface,color:T.text,fontSize:13,fontFamily:'inherit'};
  const field=(key:string,label:string,opts:{full?:boolean;type?:string;inputMode?:any}={})=>(
    <label style={{display:'flex',flexDirection:'column',gap:5,gridColumn:opts.full?'1 / -1':undefined}}>
      <span style={{fontSize:11.5,fontWeight:700,color:T.textMid}}>{t(label)}</span>
      <input value={billing[key]||''} type={opts.type||'text'} inputMode={opts.inputMode}
        onChange={e=>setBilling(b=>({...b,[key]:e.target.value}))} style={inputStyle}/>
    </label>
  );

  if (status?.provider === 'shopify') {
    const handle = shopifyShop.replace('.myshopify.com','');
    const refresh = async () => {
      setShopifySyncing(true);
      try {
        const cid = await resolveActiveClientId();
        const tok = localStorage.getItem('poyais_token') || localStorage.getItem('token') || '';
        await fetch('/api/v1/shopify/sync-billing', { method:'POST', headers:{'Content-Type':'application/json', Authorization:`Bearer ${tok}`}, body: JSON.stringify({ client_id: cid }) });
      } catch(e) {}
      window.location.reload();
    };
    return (
      <div style={{ display:'flex', flexDirection:'column', gap:20, maxWidth:760 }}>
        <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:'26px 28px'}}>
          <div style={{fontSize:11,fontWeight:700,letterSpacing:'0.08em',color:T.textDim,textTransform:'uppercase' as const}}>{t('Mevcut plan')}</div>
          <div style={{fontSize:26,fontWeight:800,color:T.text,margin:'6px 0 4px'}}>{(plans[currentPlanId]?.name) || currentPlanId}</div>
          <div style={{fontSize:13,color:T.textMid,lineHeight:1.6}}>
            {t('Aboneliğiniz Shopify üzerinden faturalandırılır. Planı değiştirmek veya iptal etmek için Shopify yönetim panelini kullanın.')}
          </div>
          <div style={{display:'flex',gap:10,flexWrap:'wrap' as const,marginTop:18}}>
            {handle && <a href={`https://admin.shopify.com/store/${handle}/settings/apps`} target="_blank" rel="noopener noreferrer"
              style={{padding:'9px 16px',borderRadius:11,background:'var(--py-gold, #C9A84C)',color:'#fff',fontSize:13,fontWeight:700,textDecoration:'none'}}>{t("Shopify'da planı yönet")}</a>}
            <button onClick={refresh} disabled={shopifySyncing}
              style={{padding:'9px 16px',borderRadius:11,border:`1px solid ${T.border}`,background:'transparent',color:T.text,fontSize:13,fontWeight:700,cursor:'pointer'}}>
              {shopifySyncing ? t('Yenileniyor...') : t('Durumu yenile')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20, maxWidth:1040 }}>
      {toast && (
        <div style={{position:'fixed',top:20,right:20,background:'var(--py-ink)',color:'#fff',padding:'11px 18px',borderRadius:10,fontSize:12.5,fontWeight:600,zIndex:9999,boxShadow:'0 8px 24px rgba(20,22,43,.18)',display:'flex',alignItems:'center',gap:8}}>
          <Icon.bell size={14} sw={2}/>{toast}
        </div>
      )}

      <ScreenHeader title={t('Faturalandırma')} subtitle={t('Mevcut planınızı görüntüleyin, yükseltin veya yönetin.')}/>

      {/* Mevcut Plan Kartı */}
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:'22px 24px',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap' as const,gap:16}}>
        <div style={{display:'flex',alignItems:'center',gap:16}}>
          <div style={{width:44,height:44,borderRadius:12,background:'var(--py-amber-tint)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
            <Icon.invoice size={20} sw={1.8} color={T.accentDeep}/>
          </div>
          <div>
            <div style={{fontSize:10.5,fontWeight:700,color:T.textDim,letterSpacing:'.08em',textTransform:'uppercase' as const,marginBottom:4}}>{t('Mevcut Plan')}</div>
            <div style={{fontSize:22,fontWeight:800,color:T.text,letterSpacing:'-0.02em'}}>{status?.plan==='admin' ? t('Özel Plan (Admin)') : (currentPlanDef?.name || t('Başlangıç'))}</div>
            <div style={{display:'flex',alignItems:'center',gap:8,marginTop:7,flexWrap:'wrap' as const}}>
              <span style={{fontSize:11,fontWeight:700,color:statusInfo.color,background:statusInfo.bg,padding:'3px 10px',borderRadius:999,display:'inline-flex',alignItems:'center',gap:5}}>
                <span style={{width:6,height:6,borderRadius:'50%',background:statusInfo.color,display:'inline-block'}}/>
                {t(statusInfo.label)}
              </span>
              {status?.trial_ends_at && status?.plan_status==='trialing' && (
                <span style={{fontSize:12,color:T.textMid}}>{lang==='en' ? `${t('tarihine kadar')} ${new Date(status.trial_ends_at).toLocaleDateString('en-US')}` : `${new Date(status.trial_ends_at).toLocaleDateString('tr-TR')} tarihine kadar`}</span>
              )}
              {status?.plan_ends_at && status?.plan_status==='canceling' && (
                <span style={{fontSize:12,color:T.textMid}}>{lang==='en' ? `${t('tarihinde sona erecek')} ${new Date(status.plan_ends_at+'Z').toLocaleDateString('en-US')}` : `${new Date(status.plan_ends_at+'Z').toLocaleDateString('tr-TR')} tarihinde sona erecek`}</span>
              )}
            </div>
          </div>
        </div>
        {hasSubscription && status?.plan_status!=='canceling' && (
          <button onClick={handleCancel} disabled={actionLoading==='cancel'}
            style={{padding:'9px 18px',borderRadius:9,border:'1px solid var(--py-red-tint)',background:'var(--py-red-tint)',color:T.redText,fontSize:12,fontWeight:700,cursor:'pointer'}}>
            {actionLoading==='cancel' ? t('İşleniyor...') : t('Aboneliği İptal Et')}
          </button>
        )}
      </div>

      {/* Dönem ve ödeme bölgesi */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap' as const,gap:12}}>
        <div style={{display:'inline-flex',gap:4,padding:4,borderRadius:11,background:'var(--py-track-bg)'}}>
          <button onClick={()=>setCycle('monthly')} style={segBtn(cycle==='monthly')}>{t('Aylık')}</button>
          <button onClick={()=>setCycle('yearly')} style={segBtn(cycle==='yearly')}>
            {t('Yıllık')} <span style={{color:T.greenText,marginLeft:4}}>{t('%20 indirim')}</span>
          </button>
        </div>
      </div>

      {/* Plan Kartları */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(270px,1fr))',gap:16}}>
        {planOrder.filter(k=>plans[k]).map(planId=>{
          const p = plans[planId];
          const isCurrent = isPaidCurrent(planId) || (planId === currentPlanId && !p.purchasable);
          const isRecommended = planId === RECOMMENDED_PLAN && !isCurrent;
          const trPrice = p.purchasable && p.price_try != null ? netMonthly(p) : null;
          const usdPrice = p.purchasable ? (cycle==='yearly' ? p.price_usd_yearly_monthly : p.price_usd) : null;
          return (
            <div key={planId} style={{
              background:T.surface,
              border: isCurrent ? `1.5px solid ${T.accent}` : isRecommended ? `1.5px solid ${T.accentDeep}` : `1px solid ${T.border}`,
              borderRadius:16, padding:'22px 22px 20px', position:'relative',
              boxShadow: isCurrent || isRecommended ? shadow.card : 'none',
            }}>
              {(isCurrent || isRecommended) && (
                <div style={{position:'absolute',top:-11,left:18,background: isCurrent ? T.accent : T.text,color: isCurrent ? 'var(--py-accent-ink)' : T.bg,fontSize:10,fontWeight:800,letterSpacing:'.04em',padding:'4px 11px',borderRadius:100}}>
                  {isCurrent ? t('MEVCUT PLAN') : t('EN POPÜLER')}
                </div>
              )}
              <div style={{fontSize:14,fontWeight:800,color:T.text,marginBottom:6,marginTop:4}}>{p.name}</div>
              <div style={{display:'flex',alignItems:'baseline',gap:5,marginBottom: p.purchasable && cycle==='yearly' ? 4 : 16}}>
                <span style={{fontSize:30,fontWeight:900,color:T.text,fontFamily:MONO,letterSpacing:'-0.02em',fontVariantNumeric:'tabular-nums'}}>
                  {!p.purchasable ? t('Özel') : region==='tr' ? (trPrice!=null ? tl(trPrice) : '—') : (usdPrice!=null ? `$${usdPrice}` : '—')}
                </span>
                {p.purchasable && <span style={{fontSize:12.5,fontWeight:600,color:T.textMid}}>{region==='tr' ? t('+ KDV /ay') : t('/ay')}</span>}
              </div>
              {region==='tr' && trPrice!=null && cycle==='yearly' && (
                <div style={{fontSize:11.5,color:T.textDim,marginBottom:12}}>{lang==='en' ? `Billed annually: ${tl(trPrice*12)} + VAT.` : `Yıllık ${tl(trPrice*12)} + KDV faturalandırılır.`}</div>
              )}
              {region==='intl' && usdPrice!=null && cycle==='yearly' && (
                <div style={{fontSize:11.5,color:T.textDim,marginBottom:12}}>{lang==='en' ? `Billed annually: $${(usdPrice*12).toLocaleString('en-US')}.` : `Yıllık $${(usdPrice*12).toLocaleString('en-US')} faturalandırılır.`}</div>
              )}
              <div style={{height:1,background:T.border,margin:'0 0 16px'}}/>
              {p.plus_label && <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:10}}>{p.plus_label[lang==='en'?'en':'tr']}</div>}
              <ul style={{listStyle:'none',display:'flex',flexDirection:'column',gap:9,marginBottom:20,padding:0}}>
                {(p.bullets?.[lang==='en'?'en':'tr']||[]).map((text:string)=>(
                  <li key={text} style={{fontSize:12.5,color:T.text,display:'flex',gap:9,alignItems:'center'}}>
                    <Icon.check size={15} sw={2} color={T.greenText}/>
                    {text}
                  </li>
                ))}
              </ul>
              {!isCurrent && p.purchasable && (
                <button onClick={()=>handleUpgrade(planId)} disabled={!!actionLoading || hasSubscription}
                  title={hasSubscription ? 'hello@poyaisone.com' : undefined}
                  style={{width:'100%',padding:'9px 16px',borderRadius:11,border:'none',background:T.accent,color:'#fff',fontSize:13,fontWeight:700,cursor:hasSubscription?'not-allowed':'pointer',opacity:hasSubscription?0.5:1,display:'flex',alignItems:'center',justifyContent:'center',gap:6}}>
                  {actionLoading===planId ? t('Yönlendiriliyor...') : <>{t('Bu Plana Geç')} <Icon.arrowRight size={14} sw={2}/></>}
                </button>
              )}
              {!isCurrent && !p.purchasable && (
                <a href="mailto:hello@poyaisone.com" style={{display:'flex',alignItems:'center',justifyContent:'center',gap:6,textAlign:'center' as const,width:'100%',padding:'11px',borderRadius:10,border:`1px solid ${T.border}`,color:T.text,fontSize:12.5,fontWeight:700,textDecoration:'none'}}>
                  {t('İletişime Geç')} <Icon.external size={13} sw={2}/>
                </a>
              )}
              {isCurrent && (
                <div style={{textAlign:'center' as const,fontSize:12,fontWeight:600,color:T.textDim,padding:'11px 0'}}>{t('Şu anki planınız')}</div>
              )}
            </div>
          );
        })}
      </div>

      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:12}}>
        <div style={{textAlign:'center' as const,fontSize:11.5,color:T.textFaint,maxWidth:640}}>
          {t("Fiyatlar KDV ve diğer vergiler hariçtir. Türkiye'den ödemeler iyzico ile TL, yurt dışından ödemeler Stripe ile USD olarak alınır; yurt dışında geçerli vergi ödeme adımında eklenir. İstediğiniz zaman iptal edebilirsiniz.")}
        </div>
        {region==='tr' && (
          <img src={lang==='en' ? '/payment/iyzico-odeme-logolari-en.png' : '/payment/iyzico-odeme-logolari-tr.png'}
            alt="iyzico, Mastercard, Visa, American Express, Troy" style={{width:260,maxWidth:'100%',height:'auto'}}/>
        )}
      </div>

      {/* iyzico ödeme penceresi */}
      {checkoutDef && (
        <div onClick={()=>actionLoading!=='iyzico' && setCheckoutPlan(null)}
          style={{position:'fixed',inset:0,background:'rgba(10,12,24,.55)',zIndex:9000,display:'flex',alignItems:'flex-start',justifyContent:'center',overflowY:'auto',padding:'40px 16px'}}>
          <div onClick={e=>e.stopPropagation()}
            style={{width:'100%',maxWidth:560,background:T.surface,borderRadius:18,border:`1px solid ${T.border}`,boxShadow:'0 24px 60px rgba(10,12,24,.3)',padding:'24px 24px 20px'}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
              <div>
                <div style={{fontSize:17,fontWeight:800,color:T.text}}>{t('Ödeme Bilgileri')}</div>
                <div style={{fontSize:12.5,color:T.textMid,marginTop:3}}>{checkoutDef.name} · {cycle==='yearly'?t('Yıllık'):t('Aylık')}</div>
              </div>
              <button onClick={()=>setCheckoutPlan(null)} disabled={actionLoading==='iyzico'} aria-label={t('Vazgeç')}
                style={{width:32,height:32,borderRadius:9,border:`1px solid ${T.border}`,background:'transparent',color:T.textMid,fontSize:18,cursor:'pointer'}}>×</button>
            </div>

            <div style={{fontSize:11,fontWeight:800,letterSpacing:'.06em',textTransform:'uppercase' as const,color:T.textDim,marginBottom:10}}>{t('Fatura Bilgileri')}</div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))',gap:12}}>
              {field('name','Ad Soyad')}
              {field('company','Firma Unvanı (Opsiyonel)')}
              {field('identity','TC Kimlik No / Vergi No',{inputMode:'numeric'})}
              {field('tax_office','Vergi Dairesi (Opsiyonel)')}
              {field('phone','Telefon',{type:'tel'})}
              {field('city','Şehir')}
              {field('address','Adres',{full:true})}
              {field('zip','Posta Kodu (Opsiyonel)',{inputMode:'numeric'})}
            </div>

            <div style={{marginTop:18,border:`1px solid ${T.border}`,borderRadius:12,padding:'12px 14px',fontSize:13,display:'flex',flexDirection:'column',gap:6}}>
              <div style={{display:'flex',justifyContent:'space-between',color:T.textMid}}><span>{t('Ara Toplam')}</span><span style={{fontFamily:MONO}}>{tl(checkoutNet,2)}</span></div>
              <div style={{display:'flex',justifyContent:'space-between',color:T.textMid}}><span>{t('KDV (%20)')}</span><span style={{fontFamily:MONO}}>{tl(checkoutVat,2)}</span></div>
              <div style={{display:'flex',justifyContent:'space-between',color:T.text,fontWeight:800,fontSize:15}}>
                <span>{t('Toplam')}</span><span style={{fontFamily:MONO}}>{tl(checkoutNet+checkoutVat,2)}</span>
              </div>
              <div style={{fontSize:11.5,color:T.textDim}}>{cycle==='yearly'?t('Yılda bir tahsil edilir'):t('Ayda bir tahsil edilir')}</div>
            </div>

            <label style={{display:'flex',alignItems:'flex-start',gap:10,marginTop:16,cursor:'pointer',fontSize:12.5,color:T.textMid,lineHeight:1.55}}>
              <input type="checkbox" checked={agreed} onChange={e=>setAgreed(e.target.checked)} style={{marginTop:2,width:16,height:16,accentColor:T.accent,flexShrink:0}}/>
              <span>
                <a href={MESAFELI_URL} target="_blank" rel="noopener noreferrer" style={{color:T.accentDeep,fontWeight:700}}>{t('Mesafeli Satış Sözleşmesi')}</a>
                {' '}{t('ve')}{' '}
                <a href={IADE_URL} target="_blank" rel="noopener noreferrer" style={{color:T.accentDeep,fontWeight:700}}>{t('Teslimat ve İade Koşulları')}</a>
                {t("'ni okudum, kabul ediyorum.")}
              </span>
            </label>

            {formError && <div style={{marginTop:12,fontSize:12.5,fontWeight:600,color:T.redText,background:'var(--py-red-tint)',padding:'9px 12px',borderRadius:9}}>{formError}</div>}

            <button onClick={submitIyzico} disabled={actionLoading==='iyzico'}
              style={{marginTop:16,width:'100%',padding:'9px 16px',borderRadius:11,border:'none',background:T.accent,color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',opacity:agreed?1:0.6}}>
              {actionLoading==='iyzico' ? t('Yönlendiriliyor...') : `${t('iyzico ile Öde')} · ${tl(checkoutNet+checkoutVat,2)}`}
            </button>
            <img src={lang==='en' ? '/payment/iyzico-odeme-logolari-en.png' : '/payment/iyzico-odeme-logolari-tr.png'}
              alt="iyzico, Mastercard, Visa, American Express, Troy" style={{display:'block',margin:'16px auto 0',width:250,maxWidth:'100%',height:'auto'}}/>
          </div>
        </div>
      )}
    </div>
  );
};
export default FaturalandirmaPage;
